export default "__VITE_ASSET__a4210072__"